import React, { Component } from 'react';
import {isInt} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";
import StatusSelector from "../../../components/common/StatusSelector";
import { paymentTypes } from '../../../components/common/payment-types';
import { supplierTypes } from "../../../components/common/supplier-types";

class SupplierDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // editable object fields
            account_code: '',
            type: -1,
            basic_info_name: '',
            basic_info_fiscal_id: '',
            basic_info_fiscal_name: '',
            basic_info_address: '',
            basic_info_postal_code: '',
            basic_info_city: '',
            basic_info_province: '',
            basic_info_country: '',
            basic_info_phone: '',
            basic_info_mobile_phone: '',
            basic_info_fax: '',
            basic_info_email: '',
            contact_person_name: '',
            contact_person_phone: '',
            contact_person_email: '',
            bank_info_name: '',
            bank_info_iban: '',
            bank_info_swift: '',
            payment_type: -1
        }
    }
    componentDidMount() {
        this.setSupplierState();
        this.props.onRef(this);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.payment_type !== prevState.payment_type) {
            if (!paymentTypes.some(type => type.get('type_code') === this.state.payment_type)) {
                this.setState({ payment_type: -1 });
            }
        }
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    setSupplierState = () => {
        this.setState({
            account_code: this.props.supplier.get('account_code') || '',
            type: this.props.supplier.get('type') || -1,
            basic_info_name: this.props.supplier.getIn(['basic_info', 'name']) || '',
            basic_info_fiscal_id: this.props.supplier.getIn(['basic_info', 'fiscal_id']) || '',
            basic_info_fiscal_name: this.props.supplier.getIn(['basic_info', 'fiscal_name']) || '',
            basic_info_address: this.props.supplier.getIn(['basic_info', 'address']),
            basic_info_postal_code: this.props.supplier.getIn(['basic_info', 'postal_code']) || '',
            basic_info_city: this.props.supplier.getIn(['basic_info', 'city']) || '',
            basic_info_province: this.props.supplier.getIn(['basic_info', 'province']) || '',
            basic_info_country: this.props.supplier.getIn(['basic_info', 'country']) || '',
            basic_info_phone: this.props.supplier.getIn(['basic_info', 'phone']) || '',
            basic_info_mobile_phone: this.props.supplier.getIn(['basic_info', 'mobile_phone']) || '',
            basic_info_fax: this.props.supplier.getIn(['basic_info', 'fax']) || '',
            basic_info_email: this.props.supplier.getIn(['basic_info', 'email']) || '',
            contact_person_name: this.props.supplier.getIn(['contact_person', 'name']) || '',
            contact_person_phone: this.props.supplier.getIn(['contact_person', 'person_phone']) || '',
            contact_person_email: this.props.supplier.getIn(['contact_person', 'email']) || '',
            bank_info_name: this.props.supplier.getIn(['bank_info', 'name']) || '',
            bank_info_iban: this.props.supplier.getIn(['bank_info', 'iban']) || '',
            bank_info_swift: this.props.supplier.getIn(['bank_info', 'swift']) || '',
            payment_type: this.props.supplier.get('payment_type') || -1
        });
    };
    validateSupplier = () => {
        if (
            this.state.type !== -1 &&
            this.state.account_code !== '' &&
            this.state.basic_info_name !== '' &&
            this.state.basic_info_fiscal_id !== '' &&
            this.state.basic_info_fiscal_name !== '' &&
            this.state.basic_info_address !== '' &&
            this.state.basic_info_postal_code !== '' &&
            this.state.basic_info_city !== '' &&
            this.state.basic_info_province !== '' &&
            this.state.basic_info_country !== '' &&
            this.state.contact_person_name !== '' &&
            this.state.bank_info_name !== '' &&
            this.state.payment_type !== -1
        ) {
            this.props.canSubmit(true);
        } else {
            this.props.canSubmit(false);
        }
    };
    updateSupplier = () => {
        this.props.updateSupplier(this.props.supplier.get('_id'), {
            account_code: this.state.account_code,
            type: this.state.type,
            basic_info: {
                name: this.state.basic_info_name,
                fiscal_id: this.state.basic_info_fiscal_id,
                fiscal_name: this.state.basic_info_fiscal_name,
                address: this.state.basic_info_address,
                postal_code: this.state.basic_info_postal_code,
                city: this.state.basic_info_city,
                province: this.state.basic_info_province,
                country: this.state.basic_info_country,
                phone: this.state.basic_info_phone,
                mobile_phone: this.state.basic_info_mobile_phone,
                fax: this.state.basic_info_fax,
                email: this.state.basic_info_email,
            },
            contact_person: {
                name: this.state.contact_person_name,
                phone: this.state.contact_person_phone,
                email: this.state.contact_person_email,
            },
            bank_info: {
                name: this.state.bank_info_name,
                iban: this.state.bank_info_iban,
                swift: this.state.bank_info_swift,
            },
            payment_type: this.state.payment_type
        });
    };

    render() {
        let formBody;
        let statusColor = '', statusText = '';

        switch (this.props.supplier.get('status')) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        if (!this.props.editMode) {
            formBody = (
                <div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de Proveedor *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.props.supplier.get('supplier_code')}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Tipo de Proveedor *</label>
                                <Select
                                    className="virtualized-select"
                                    options={supplierTypes.toJS()}
                                    value={this.state.type}
                                    labelKey="type_name"
                                    valueKey="type_code"
                                    matchProp="type_name"
                                    multi={false}
                                    searchable={false}
                                    clearable={false}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3 ml-auto">
                            <label>Estado</label>
                            <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                                <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                    <StatusSelector
                                        statusObject={this.props.supplier}
                                        statusOptions={['active', 'inactive']}
                                        changeStatus={this.props.changeSupplierStatus}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>NIF/CIF *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_fiscal_id}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Cuenta Contable *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.account_code}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Nombre comercial</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_name}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label>Nombre fiscal *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_fiscal_name}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Domicilio</h4>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>Dirección *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_address}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>País *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_country}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Provincia *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_province}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Población *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_city}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código Postal *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_postal_code}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Contacto</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    disabled={true}
                                    value={this.state.basic_info_email}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_phone}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Móvil</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_mobile_phone}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fax</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.basic_info_fax}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Persona de Contacto</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Nombre *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.contact_person_name}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    disabled={true}
                                    value={this.state.contact_person_email}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.contact_person_phone}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Datos bancarios</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Forma de pago *</label>
                                <Select
                                    className="virtualized-select"
                                    options={paymentTypes.toJS()}
                                    value={this.state.payment_type}
                                    labelKey="type_name"
                                    valueKey="type_code"
                                    matchProp="type_name"
                                    multi={false}
                                    searchable={false}
                                    clearable={false}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Banco *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.bank_info_name}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>IBAN</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.bank_info_iban}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Swift</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.state.bank_info_swift}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            formBody = (
                <div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de Proveedor *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    disabled={true}
                                    value={this.props.supplier.get('supplier_code')}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Tipo de Proveedor *</label>
                                <Select
                                    className="virtualized-select"
                                    options={supplierTypes.toJS()}
                                    value={this.state.type}
                                    labelKey="type_name"
                                    valueKey="type_code"
                                    matchProp="type_name"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    onChange={(valueSelected) => {
                                        if (valueSelected) {
                                            this.setState({
                                                type: valueSelected.type_code
                                            }, this.validateSupplier);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-3 ml-auto">
                            <label>Estado</label>
                            <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>NIF/CIF *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_fiscal_id}
                                    onChange={ (event) => this.setState({ basic_info_fiscal_id: event.target.value }, this.validateSupplier) }
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Cuenta Contable *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.account_code}
                                    onChange={ (event) => {
                                        if (isInt(event.target.value) || event.target.value === '') {
                                            this.setState({ account_code: event.target.value }, this.validateSupplier);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Nombre comercial</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_name}
                                    onChange={ (event) => this.setState({ basic_info_name: event.target.value }, this.validateSupplier) }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label>Nombre fiscal *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_fiscal_name}
                                    onChange={ (event) => this.setState({ basic_info_fiscal_name: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Domicilio</h4>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>Dirección *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_address}
                                    onChange={ (event) => this.setState({ basic_info_address: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>País *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_country}
                                    onChange={ (event) => this.setState({ basic_info_country: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Provincia *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_province}
                                    onChange={ (event) => this.setState({ basic_info_province: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Población *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_city}
                                    onChange={ (event) => this.setState({ basic_info_city: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código Postal *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_postal_code}
                                    onChange={ (event) => {
                                        if (isInt(event.target.value) || event.target.value === '') {
                                            this.setState({ basic_info_postal_code: event.target.value }, this.validateSupplier);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Contacto</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    value={this.state.basic_info_email}
                                    onChange={ (event) => this.setState({ basic_info_email: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_phone}
                                    onChange={ (event) => this.setState({ basic_info_phone: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Móvil</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_mobile_phone}
                                    onChange={ (event) => this.setState({ basic_info_mobile_phone: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fax</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.basic_info_fax}
                                    onChange={ (event) => this.setState({ basic_info_fax: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Persona de Contacto</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Nombre *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.contact_person_name}
                                    onChange={ (event) => this.setState({ contact_person_name: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    value={this.state.contact_person_email}
                                    onChange={ (event) => this.setState({ contact_person_email: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.contact_person_phone}
                                    onChange={ (event) => this.setState({ contact_person_phone: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                    </div>
                    <h4>Datos bancarios</h4>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Forma de pago *</label>
                                <Select
                                    className="virtualized-select"
                                    options={paymentTypes.toJS()}
                                    value={this.state.payment_type}
                                    labelKey="type_name"
                                    valueKey="type_code"
                                    matchProp="type_name"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    scrollMenuIntoView={true}
                                    onChange={(valueSelected) => {
                                        if (valueSelected) {
                                            this.setState({ payment_type: valueSelected.type_code }, this.validateSupplier);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Banco *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.bank_info_name}
                                    onChange={ (event) => this.setState({ bank_info_name: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>IBAN</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.bank_info_iban}
                                    onChange={ (event) => this.setState({ bank_info_iban: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Swift</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.bank_info_swift}
                                    onChange={ (event) => this.setState({ bank_info_swift: event.target.value }, this.validateSupplier)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return formBody;
    }
}

export default SupplierDetail;



// WEBPACK FOOTER //
// ./src/containers/purchases/suppliers/SupplierDetail.js